import Vue from 'vue'
import VueRouter from 'vue-router'
import UserLogin from '../views/UserLogin.vue'
import UserChangePassword from '../views/UserChangePassword.vue'
import UserRegister from '../views/UserRegister.vue'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        path: '/login',
        name: 'UserLogin',
        component: UserLogin
    },
    {
        path: '/register',
        name: 'UserRegister',
        component: UserRegister
    },
    {
        path: '/change-password',
        name: 'UserChangePassword',
        component: UserChangePassword
    },
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [{
                path: 'hot',
                name: 'Hot',
                component: () =>
                    import ('@/views/hot/index.vue'),
                meta: { title: '热门频道' }
            },
            {
                path: 'channel/:id',
                name: 'Channel',
                component: () =>
                    import ('@/views/channel/index.vue'),
                meta: { title: '频道详情' }
            },
            {
                path: 'config',
                name: 'Config',
                component: () =>
                    import ('@/views/config/index.vue'),
                meta: { title: '配置收听方式' }
            },
            {
                path: 'home',
                name: 'Home',
                component: () =>
                    import ('@/views/home/index.vue'),
                meta: { title: '首页' }
            },
            {
                path: '/profile',
                name: 'Profile',
                component: () =>
                    import ('@/views/profile/index.vue'),
                meta: {
                    title: '个人资料',
                    icon: 'el-icon-user'
                }
            },
            {
                path: '/mine',
                name: 'Mine',
                component: () =>
                    import ('@/views/mine/index.vue'),
                meta: {
                    title: '我的',
                    icon: 'el-icon-user'
                }
            },
            {
                path: '/insight',
                name: 'Insight',
                component: () =>
                    import ('@/views/insight/index.vue'),
                meta: {
                    title: '洞察',
                    icon: 'el-icon-user'
                }
            },
            {
                path: '/subscribe',
                name: 'Subscribe',
                component: () =>
                    import ('@/views/subscribe/index.vue'),
                meta: {
                    title: '订阅',
                    icon: 'el-icon-user'
                }
            },
            {
                path: '/notice',
                name: 'Notice',
                component: () =>
                    import ('@/views/notice/index.vue'),
                meta: {
                    title: '公告',
                    icon: 'el-icon-user'
                }
            },
            {
                path: '/sources-manage',
                name: 'MineSources',
                component: () =>
                    import ('@/views/mine-sources/index.vue'),
                meta: {
                    title: '我的消息源',
                    icon: 'el-icon-user'
                }
            }
        ]
    }
]

const router = new VueRouter({
    routes
})

router.afterEach(() => {
    // 使用Vue.nextTick确保DOM已经更新
    Vue.nextTick(() => {
        document.querySelector('.app-wrapper').scrollTo(0, 0);
    });
});

export default router